import _ from 'lodash';
import NRS from '@/views/constants/report-of-sickness-new';
import ReportsOfSicknessView from '@/views/constants/reports-of-sickness';

const Steps = {
  create () {
    return [{
      number: 1,
      title: 'Selecteer werknemer',
      text: 'Selecteer de werknemer waarvoor u een ziekmelding wilt indienen.',
      completed: false,
      active: true,
      view: NRS.Views.SelectEmployeeForm,
      navigateAction: NRS.Actions.Navigate.DO
    },
    {
      number: 2,
      title: 'Invoer ziekmelding',
      text: 'Voer de gegevens van het verzuim in. U dient alle velden in te vullen, tenzij deze gemarkeerd zijn met "(optioneel)".',
      completed: false,
      active: false,
      view: NRS.Views.NewReportOfSicknessForm,
      navigateAction: NRS.Actions.Navigate.DO
    },
    {
      number: 3,
      title: 'Bevestiging ziekmelding',
      text: 'Controleer alle gegevens en geef bevestiging om de ziekmelding daadwerkelijk in te dienen',
      completed: false,
      active: false,
      view: NRS.Views.NewReportOfSicknessConfirmation,
      navigateAction: NRS.Actions.Navigate.DO
    }];
  }
};

const state = {
  newReportOfSicknessSteps: Steps.create()
};

const getters = {
  newReportOfSicknessSteps: state => state.newReportOfSicknessSteps,
  newReportOfSicknessActiveView: state => state.newReportOfSicknessSteps.find(s => s.active).view
};

const actions = {
  [NRS.Actions.Navigate.DO] ({ commit, rootGetters }, view) {
    if (view !== NRS.Views.SelectEmployeeForm) {
      if (rootGetters.newReportOfSickness.employeeId == null) {
        return;
      }
    }

    if (view === NRS.Views.NewReportOfSicknessConfirmation) {
      if (!(rootGetters.newReportOfSicknessValidations.isValid() &&
        rootGetters.newReportOfSicknessRequiredFields.isValid())) {
        return;
      }
    }

    commit(NRS.Mutations.ActiveView.SET, view);
  },

  [NRS.Actions.Steps.Completed.UPDATE] ({ commit, rootGetters }) {
    const _formValid =
      rootGetters.newReportOfSicknessValidations.isValid() &&
      rootGetters.newReportOfSicknessRequiredFields.isValid();

    commit(NRS.Mutations.Steps.Completed.SET, {
      isEmployeePresent: !_.isNil(rootGetters.newReportOfSickness.employeeId),
      isFormValid: _formValid
    });
  },

  [NRS.Actions.Cancel.DO] ({ commit }) {
    commit(NRS.Mutations.CLEAR);
  },

  [ReportsOfSicknessView.Actions.Tabs.CLOSE] ({ commit }, tab) {
    if (tab.component === 'NewReportOfSickness') {
      commit(NRS.Mutations.CLEAR);
    }
  }
};

const mutations = {
  [NRS.Mutations.ActiveView.SET] (state, payload) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    state.newReportOfSicknessSteps.forEach(s => {
      s.active = (s.view === payload);
    });
  },

  [NRS.Mutations.CLEAR] (state) {
    state.newReportOfSicknessSteps = Steps.create();
  },

  [NRS.Mutations.Steps.Completed.SET] (state, payload) {
    state.newReportOfSicknessSteps.forEach(s => {
      switch (s.view) {
        case NRS.Views.SelectEmployeeForm:
          s.completed = payload.isEmployeePresent;
          break;
        case NRS.Views.NewReportOfSicknessForm:
          s.completed = payload.isFormValid;
          break;
      }
    });
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
